import axios from "axios";
import { Base_URL } from "../url";

export const fetchPurchaseOrders = async () => {
  try {
    const response = await axios.get(`${Base_URL}/PurchaseOrder/GetAllPurchaseOrders`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching purchase orders!";
  }
};
export const fetchPurchaseOrdersAll = async () => {
  try {
    const response = await axios.get(`${Base_URL}/PurchaseOrder/GetAllPurchaseOrdersWithoutFilter`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching purchase orders!";
  }
};
export const fetchPurchaseOrdersWithoutVendor = async () => {
  try {
    const response = await axios.get(`${Base_URL}/VendorInvoice/PurchaseOrder`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching purchase orders!";
  }
};

export const downloadPurchaseOrdersExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/PurchaseOrder/DownloadPurchaseOrdersExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading purchase orders data!";
  }
};